import type { ProbeTraceStep } from '@terra/shared-contracts-assets';

export const matchesProbeTraceStepSearch = ({
  step,
  query,
}: {
  step: ProbeTraceStep;
  query: string;
}): boolean => {
  const normalizedQuery = query.trim().toLowerCase();

  if (!normalizedQuery) {
    return true;
  }

  return [
    step.title,
    step.statusLabel,
    step.summary,
    step.code,
    step.result,
  ].some((value) => value?.toLowerCase().includes(normalizedQuery));
};

export const filterProbeTraceSteps = ({
  steps,
  query,
}: {
  steps: ProbeTraceStep[];
  query: string;
}): ProbeTraceStep[] =>
  steps.filter((step) => matchesProbeTraceStepSearch({ step, query }));
